module.exports = __webpack_public_path__ + "media/assets/icons/new-window-a088ef56847404b8cd9996ae23d8b744.svg";